const manutencao_de_equivalencia_estudos_extra_rede = {
  path: "/manutencao-de-equivalencia-estudos-extra-rede",
  redirect: "/manutencao-de-equivalencia-estudos-extra-rede",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Manutenção do Histórico",
    allowedPermissions: ["equivalencia_ensino_extra_rede_show"],
  },
  children: [
    {
      path: "/manutencao-de-equivalencia-estudos-extra-rede",
      name: "manutencao_de_equivalencia_estudos_extra_rede",
      component: () =>
        import(
          "@/views/ManutencaoDeEquivalenciaEstudosExtraRede/ManutencaodeEquivalenciaEstudosExtraRedeHome.vue"
        ),
      meta: {
        allowedPermissions: ["equivalencia_ensino_extra_rede_list"],
      },
    },
    {
      path: "/manutencao-de-equivalencia-estudos-extra-rede/novo",
      name: "cadastrar_manutencao_de_equivalencia_estudos_extra_rede",
      component: () =>
        import(
          "@/views/ManutencaoDeEquivalenciaEstudosExtraRede/ManutencaodeEquivalenciaEstudosExtraRedeCad.vue"
        ),
      meta: {
        allowedPermissions: ["equivalencia_ensino_extra_rede_create"],
      },
    },
    {
      path: "/manutencao-de-equivalencia-estudos-extra-rede/editar/:id",
      name: "editar_manutencao_de_equivalencia_estudos_extra_rede",
      component: () =>
        import(
          "@/views/ManutencaoDeEquivalenciaEstudosExtraRede/ManutencaodeEquivalenciaEstudosExtraRedeEdit.vue"
        ),
      meta: {
        allowedPermissions: ["equivalencia_ensino_extra_rede_edit"],
      },
    },
  ],
};
export { manutencao_de_equivalencia_estudos_extra_rede };
